const MODAL_NAMES = {
  THREE_SIXTY_FEEDBACK: {
    //value modals
    CREATE_VALUE_MODAL: "create-value-modal",
    EDIT_VALUE_MODAL: "edit-value-modal",
    UPDATE_VALUE_MODAL: "update-value-modal",
    DELETE_VALUE_MODAL: "delete-value-modal",

    //leadership modals
    CREATE_LEADERSHIP_MODAL: "create-leadership-modal",
    EDIT_LEADERSHIP_MODAL: "edit-leadership-modal",
    UPDATE_LEADERSHIP_MODAL: "update-leadership-modal",
    DELETE_LEADERSHIP_MODAL: "delete-leadership-modal",

    //project modals
    CREATE_PROJECT_MODAL: "create-project-modal",
    EDIT_PROJECT_MODAL: "edit-project-modal",
    UPDATE_PROJECT_MODAL: "update-project-modal",
    DELETE_PROJECT_MODAL: "delete-project-modal",

    //rating term
    CREATE_RATING_TERM: "create-rating-term",
    EDIT_RATING_TERM: "edit-rating-term",

    //template modals
    CREATE_TEMPLATE_MODAL: "create-service-modal",
    EDIT_TEMPLATE_MODAL: "edit-service-modal",
    UPDATE_TEMPLATE_MODAL: "update-service-modal",
    DELETE_TEMPLATE_MODAL: "delete-service-modal",

    //preview
    QUESTIONNAIRE_PREVIEW: "questionnaire-preview",

    //ALERTS
    SUCCESSFULLY_SUBMITTED_MODAL: "successfully-submitted-modal",
    SUCCESSFULLY_REQUESTED_MODAL: "successfully-requested-modal",
    SUCCESSFULLY_STARTED_SESSION_MODAL: "successfully-started-session",
    SUCCESSFULLY_ENDED_SESSION_MODAL: "successfully-ended-session-modal",
    SUCCESSFULLY_Deleted_MODAL: "successfully-deleted-modal",
  },

  EXECUTION: {
    VIEW_REVIEW_MODAL: "view-review-modal",
    MAP_OVERVIEW_MODAL: "map-overview-modal",
    COMPANY_MAP_OVERVIEW_MODAL: "company-map-overview-modal",
    OBJECTIVE_MODAL: "objective-modal",
    DUPLICATION_MODAL: "duplication-modal",
    DUPLICATION_MODAL_I: "duplication-modal_i",
    SCORECARD_DISPUTE_MODAL: "scorecard-dispute-modal",
    SCORECARD_RESOLVE_DISPUTE_MODAL: "scorecard-resolve-dispute-modal",
    COMPANY_MEASURE_STATUS_UPDATE_MODAL: "company-measure-status-update-modal",
    COMPANY_MEASURE_COMMENTS_MODAL: "company-measure-status-update-modal",

    COMPANY_MEASURE_UPDATE_Q1_ACTUAL_MODAL:
      "company-measure-update-q1-actual-modal",
    COMPANY_MEASURE_UPDATE_Q2_ACTUAL_MODAL:
      "company-measure-update-q2-actual-modal",
    COMPANY_MEASURE_UPDATE_Q3_ACTUAL_MODAL:
      "company-measure-update-q3-actual-modal",
    COMPANY_MEASURE_UPDATE_Q4_ACTUAL_MODAL:
      "company-measure-update-q4-actual-modal",
    OBJECTIVE_DRAFT_COMMENT_MODAL: "objective-draft-comment-modal",
    OBJECTIVE_Q2_COMMENT_MODAL: "objective-q2-comment-modal",
    OBJECTIVE_Q4_COMMENT_MODAL: "objective-q4-comment-modal",

    COMPANY_DRAFT_APPROVAL_MODAL: "company-draft-approval-modal",
    COMPANY_DRAFT_REJECTION_MODAL: "company-draft-rejection-modal",
    COMPANY_Q1_APPROVAL_MODAL: "company-q1-approval-modal",
    COMPANY_Q1_REJECTION_MODAL: "company-q1-rejection-modal",
    COMPANY_Q2_APPROVAL_MODAL: "company-q2-approval-modal",
    COMPANY_Q2_REJECTION_MODAL: "company-q2-rejection-modal",
    COMPANY_Q3_APPROVAL_MODAL: "company-q3-approval-modal",
    COMPANY_Q3_REJECTION_MODAL: "company-q3-rejection-modal",
    COMPANY_Q4_APPROVAL_MODAL: "company-q4-approval-modal",
    COMPANY_Q4_REJECTION_MODAL: "company-q4-rejection-modal",
    VIEW_OBJECTIVE_DRAFT_COMMENT_MODAL: "view-objective-draft-comment-modal",
    VIEW_OBJECTIVE_Q2_COMMENT_MODAL: "view-objective-q2-comment-modal",
    VIEW_OBJECTIVE_Q4_COMMENT_MODAL: "view-objective_q4-comment-modal",

    OBJECTIVE_COMPANY_DRAFT_COMMENT_MODAL:
      "objective-company-draft-comment-modal",
    OBJECTIVE_COMPANY_Q2_COMMENT_MODAL: "objective-company-q2-comment-modal",
    OBJECTIVE_COMPANY_Q4_COMMENT_MODAL: "objective-company-q4-comment-modal",

    VIEW_OBJECTIVE_COMPANY_DRAFT_COMMENT_MODAL:
      "view-objective-company-draft-comment-modal",
    VIEW_OBJECTIVE_COMPANY_Q2_COMMENT_MODAL:
      "view-objective-company-q2-comment-modal",
    VIEW_OBJECTIVE_COMPANY_Q4_COMMENT_MODAL:
      "view-objective-company-q4-comment-modal",

    DEPARTMENT_OBJECTIVE_MODAL: "department-objective-modal",
    DEPARTMENT_MEASURE_COMMENTS_MODAL: "department-measure-status-update-modal",
    DEPARTMENT_MEASURE_MODAL: "department-measure-modal",
    DEPARTMENT_MEASURE_UPDATE_Q1_ACTUAL_MODAL:
      "department-measure-update-q1-actual-modal",
    DEPARTMENT_MEASURE_UPDATE_Q2_ACTUAL_MODAL:
      "department-measure-update-q2-actual-modal",
    DEPARTMENT_MEASURE_UPDATE_Q3_ACTUAL_MODAL:
      "department-measure-update-q3-actual-modal",
    DEPARTMENT_MEASURE_UPDATE_Q4_ACTUAL_MODAL:
      "department-measure-update-q4-actual-modal",
    DEPARTMENT_DRAFT_APPROVAL_MODAL: "department-draft-approval-modal",

    READ_DEPARTMENT_SCORECARD_COMMENT_MODAL:
      "read-department-scorecard-comment-modal",

    // READ_COMPANY_SCORECARD_COMMENT_MODAL:
    //   "read-company-scorecard-comment-modal",

    DEPARTMENT_DRAFT_REJECTION_MODAL: "department-draft-rejection-modal",
    DEPARTMENT_Q1_APPROVAL_MODAL: "department-q1-approval-modal",
    DEPARTMENT_Q1_REJECTION_MODAL: "department-q1-rejection-modal",
    DEPARTMENT_Q2_APPROVAL_MODAL: "department-q2-approval-modal",
    DEPARTMENT_Q2_REJECTION_MODAL: "department-q2-rejection-modal",
    DEPARTMENT_Q3_APPROVAL_MODAL: "department-q3-approval-modal",
    DEPARTMENT_Q3_REJECTION_MODAL: "department-q3-rejection-modal",
    DEPARTMENT_Q4_APPROVAL_MODAL: "department-q4-approval-modal",
    DEPARTMENT_Q4_REJECTION_MODAL: "department-q4-rejection-modal",

    READ_SCORECARD_COMMENT_MODAL: "read-scorecard-comment-modal",
    MEASURE_MODAL: "measure-modal",
    MEASURE_READ_ONLY_MODAL: "measure-read-only-modal",
    PERSPECTIVE_WEIGHTS_MODAL: "perspective-weights-modal",
    MEASURE_FILES_MODAL: "measure-files-modal",
    MEASURE_COMMENTS_MODAL: "measure-comments-modal",
    MEASURE_COMMENTS_MIDTERM_MODAL: "measure-comments-midterm-modal",
    MEASURE_COMMENTS_ASSESSMENT_MODAL: "measure-comments-assessment-modal",
    PERSONAL_DEVELOPMENT_UPDATE_MODAL: "personal-development-update-modal",
    PERSONAL_DEVELOPMENT_QUALIFICATIONS_MODAL:
      "personal-development-qualifications-modal",
    PERSONAL_DEVELOPMENT_VIEW_TRAINING_MODAL:
      "personal-development-view-training-modal",
    PERSONAL_DEVELOPMENT_COMPLETE_TRAINING_MODAL:
      "personal-development-complete-training-modal",
    PERSONAL_DEVELOPMENT_APPROVE_TRAINING_MODAL:
      "personal-development-approve-training-modal",
    PERSONAL_DEVELOPMENT_REQUEST_TRAINING_MODAL:
      "personal-development-request-training-modal",
    PERSONAL_DEVELOPMENT_CREATE_TRAINING_CATALOG_MODAL:
      "personal-development-create-training-catalog-modal",
    MEASURE_COMMENTS_COMPANY_MODAL: "measure-comments-company-modal",
    MEASURE_COMMENTS_COMPANY_MIDTERM_MODAL:
      "measure-comments-company-midterm-modal",
    MEASURE_COMMENTS_COMPANY_ASSESSMENT_MODAL:
      "measure-comments-company-assessment-modal",

    MEASURE_UPDATE_MODAL: "measure-update-modal",
    MEASURE_UPDATE_ACTUAL_MODAL: "measure-update-actual-modal",
    MEASURE_UPDATE_Q4_ACTUAL_MODAL: "measure-update-q4-actual-modal",

    PERFORMANCE_AGREEMENT_DRAFT_APPROVAL_MODAL:
      "performance-agreement-draft-approval-modal",
    PERFORMANCE_AGREEMENT_DRAFT_REJECTION_MODAL:
      "performance-agreement-draft-rejection-modal",

    PERFORMANCE_MIDTERM_APPROVAL_MODAL: "performance-midterm-approval-modal",
    PERFORMANCE_MIDTERM_REJECTION_MODAL: "performance-midterm-rejection-modal",

    PERFORMANCE_ASSESSMENT_APPROVAL_MODAL:
      "performance-assessment-approval-modal",
    PERFORMANCE_ASSESSMENT_REJECTION_MODAL:
      "performance-assessment-rejection-modal",

    COMPANY_MEASURE_MODAL: "company-measure-modal",
    COMPANY_MEASURE_UPDATE_ACTUAL_MODAL: "company-measure-update-actual-modal",

    READ_COMPANY_SCORECARD_COMMENT_MODAL:
      "read-company-scorecard-comment-modal",
    COMPANY_PERSPECTIVE_WEIGHTS_MODAL: "company-perspective-weights-modal",

    COMPANY_MEASURE_Q2_UPDATE_MODAL: "company-measure-q2-update-modal",
    COMPANY_MEASURE_Q4_UPDATE_MODAL: "company-measure-q4-update-modal",

    TASK_MODAL: "task-modal",
    PROJECT_MODAL: "project-modal",
    SCORECARD_MODAL: "scorecard-modal",
  },
  PERFORMANCE_REVIEW: {
    REVIEW_MODAL: "performance-review-modal",
    GIVE_REVIEW_MODAL: "give-review-modal",
    MAIL_ALL_EMPLOYEES_MODAL: "mail-all-employees-modal",
  },
  PROOF_OF_WORK: {
    FOLDER_MODAL: "folder-modal",
    FOLDER_FILE_MODAL: "folder-file-modal",
    FOLDER_FILE_UPLOADER_MODAL: "folder-file-uploader-modal",
  },
  ADMIN: {
    USER_MODAL: "user-modal",
    ROLE_MODAL: "role-modal",
    VM_MODAL: "vision-mission-modal",
    SCORECARD_BATCH_MODAL: "scorecard-batch-modal",
    DEPARTMENT_MODAL: "department-modal",
    DIVISION_MODAL: "division-modal",
    BUSINESS_UNIT_MODAL: "business-unit-modal",
    STRATEGIC_THEME_MODAL: "strategic-theme-modal",
  },
  DASHBOARD: {
    READ_MORE_MODAL: "read-more-modal",
  },
  TEAM: {
    TEAM_MEASURE_MODAL: "team-measure-modal",
    TEAM_OBJECTIVE_MODAL: "team-objective-modal",
    TEAM_PERSPECTIVE_MODAL: "team-prespective-modal",
  },
  PROJECTS: {
    CREATE_PROJECT: "newProject-Modal",
    CREATE_TASK: "newTask-Modal",
    CREATE_MILESTONE: "newMilestone-Modal",
    CREATE_RISK: "newRisk-modal",
    CREATE_PORTFOLIO: "newPortfolio-modal",
    VIEW_TASK: "view-Task-Modal",
    VIEW_RISK: "view-Risk-Modal",
    ADD_USER: "add-user-modal",
    PROJECT_FILES: "project-files-modal",
    ATTACH_MILESTONE_BILL: "attach-bill-modal",
  },
  FEEDBACK: {
    CREATE: "feedback-create-modal",
  },

  GENERAL_TASKS: {
    CREATE_GENERAL_TASK: "general-tasks-modal",
    VIEW_GENERAL_TASKS: "view-general-task-modal",
  },
  BONUS_REPORT: {
    UPDATE_PERIOD: "update-period",
  },
};

export default MODAL_NAMES;
